import { MI_COVERAGE_ACTION_TYPE } from '../actions';

const initialState = {};

const miCoverageSchemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case MI_COVERAGE_ACTION_TYPE.GET_SCHEMA:
      return payload || initialState;

    default:
      return state;
  }
};

export default miCoverageSchemaReducer;
